import styled, { createGlobalStyle, css } from "styled-components";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { ScrollWrapper } from "@ubnt/store.core/lib/components/ScrollWrapper";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  max-width: 100vw;
  width: 100%;

  :last-child {
    height: 100% !important;
  }
`;

export const StyledTourWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  direction: ltr;
  overflow: hidden;
  min-height: 990px;

  @media (max-width: 1524px) {
    min-height: 600px;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    min-height: unset;
  }
`;

export const TourContainer = styled.div<{
  $isVisible: boolean;
}>`
  margin: 0 80px;
  position: absolute;
  max-width: min(1356px, calc(100vw - 160px));
  width: 100%;
  opacity: 0;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin: 0 16px;
    max-width: calc(100vw - 32px);
  }

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      opacity: 1;
      position: relative;
      left: 0;
      z-index: 1;
      opacity: 1;
    `}
`;

export const HologramContainer = styled.div`
  padding-bottom: 23.7%;
  position: relative;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    padding-top: 128px;
    max-width: 100%;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding-top: 0;
    width: calc(100% + 168px);
    margin-right: -84px;
    margin-left: -84px;
    max-width: unset;
  }
`;

export const HologramVideo = styled.video`
  object-fit: contain;
  width: 100%;
  position: absolute;
  inset: auto 0 0 0;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    min-height: 104px;
    object-fit: cover;
  }
`;

export const TourContentContainer = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;
  max-height: 720px;
  max-width: 100vw;
  padding: 0 16px;
  padding: 0px 16px;
  width: 100%;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding: 0 8px;
  }
`;

export const RackVideo = styled.video`
  position: absolute;
  left: 0;
  bottom: 0;
  object-fit: contain;
  max-height: 76%;
  transform: translateX(-60%);

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    display: none;
  }
`;

export const BezelImageContainer = styled.div`
  aspect-ratio: 3683/2160;
  max-width: 1156px;
  margin: 0 auto;
  width: 100%;
  max-height: 86%;
  z-index: 1;
  pointer-events: none;
`;

export const MobileAbsoluteContainer = styled.div`
  right: -56px;
  z-index: 3;
  bottom: -4px;
  position: absolute;
  display: flex;
  align-items: flex-end;
`;

export const VideoWrapper = styled.div`
  height: auto;
  position: absolute;
  display: flex;
  left: 50%;
  max-width: 1157px;
  width: 100%;
  transform: translateX(-50%);
  margin: 0 auto;
  top: calc(2.9%);
  height: calc(100% - 5.8%);

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    top: calc(2.8%);
    height: calc(100% - 5.6%);
  }
`;

export const BezelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
`;

export const MobileBezelContainer = styled(BezelContainer)<{
  $scale: number;
}>`
  transform: scale(${({ $scale }) => $scale});
  transform-origin: bottom right;
`;

export const ScreenVideo = styled.video`
  object-fit: fill;
  width: 96.9%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.neutral00};
`;

export const BezelImage = styled.img`
  width: 100%;
`;

export const IphoneBezelContainer = styled.div`
  position: relative;
  max-width: 234px;
  margin: 0 auto;
  width: 100%;
  max-height: 86%;
  z-index: 1;
  pointer-events: none;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    display: none;
  }
`;

export const IphoneVideoWrapper = styled.div`
  height: 100%;
  max-height: calc(100% - 4.15%);
  position: absolute;
  display: flex;
  left: 50%;
  max-width: 234px;
  width: 100%;
  transform: translateX(-50%);
  margin: 0 auto;
  top: calc(4px + 1%);
  overflow: hidden;
  border-radius: 15%;
`;

export const IphoneScreenVideo = styled.video`
  object-fit: contain;
  width: 91.2%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.neutral00};
`;

export const IphoneBezelImage = styled.img`
  width: 100%;
`;

export const InViewMonitorStyles = createGlobalStyle`
  .monitor-in-view {
    height: 100%;
  }
`;

export const TourSectionWrapper = styled.div`
  position: relative;
  margin-top: 48px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    position: static;
    margin-bottom: 28px;
  }
`;

export const StyledScrollWrapper = styled(ScrollWrapper)`
  background: transparent;
  display: flex;
  padding: 0 16px;
  width: 100%;
  margin-bottom: 0;

  .scroll-container-item {
    height: 100%;
  }

  > div {
    padding: 16px 0 16px 4px;
    gap: 12px;
    margin: 0;

    @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
      padding: 8px 0 8px 4px;
    }
  }
`;

export const ApplicationSwitcherWrap = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
  padding: 0 8px;
  flex-wrap: wrap;
`;

export const TitleSwitchContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    position: static;
    gap: 24px;
  }
`;
